export default {
  getDomainName () {
    return window.location.hostname
  },
  getQueryStringValue (name) {
    let url = window.location.href
    name = name.toLowerCase()
    const urlTokens = url.split('?')
    if (urlTokens.length === 1) {
      return ''
    }

    const queryString = urlTokens[1]
    const queryStringTokens = queryString.split('&')
    for (let i = 0; i < queryStringTokens.length; i++) {
      const tokenTokens = queryStringTokens[i].split('=')
      if (tokenTokens.length !== 2) {
        continue
      }

      if (tokenTokens[0].toLowerCase() === name) {
        return tokenTokens[1]
      }
    }
    return ''
  },
  createGUID () {
    const s4 = () => {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1)
    }

    return `${s4()}${s4()}${s4()}${s4()}${s4()}${s4()}${s4()}${s4()}`
  },
  redirectTo (target) {
    this.$router.push({ path: target })
  }
}
